import { AvailableLiquidity } from "@portal/types/robot/IRobotEnums";

export const MapIndexToLiquidity = (selectedIndex: number | null) => {
  if (selectedIndex === 0) return null;
  if (selectedIndex === 1) return AvailableLiquidity.From100To2000;
  if (selectedIndex === 2) return AvailableLiquidity.From2000To10000;
  if (selectedIndex === 3) return AvailableLiquidity.Over10000;
  return null;
};

export const MapLiquidityToIndex = (liquidity: AvailableLiquidity | null) => {
  if (liquidity === AvailableLiquidity.From100To2000) return 1;
  if (liquidity === AvailableLiquidity.From2000To10000) return 2;
  if (liquidity === AvailableLiquidity.Over10000) return 3;
  return null;
};
